import HeroSection from '../components/home/HeroSection'
import CategoriesSection from '../components/home/CategoriesSection'
import ArtifactShowcaseSection from '../components/home/ArtifactShowcaseSection'
import JournalSection from '../components/home/JournalSection'
import FinalCTASection from '../components/home/FinalCTASection'

const Home = () => (
  <div>
    <HeroSection />
    <CategoriesSection />
    <ArtifactShowcaseSection />
    <JournalSection />
    <FinalCTASection />
  </div>
)

export default Home
